import { Component, OnInit, ViewChild } from '@angular/core';
import { ENTITY_NAMES, RECORD_STATUS_VALUES } from '../../shared/constants/api-constants';
import { DmcQuoteItineraryDetailsComponent } from './itinerary-details/dmc-quote-itinerary-details.component';
import { DmcQuoteViewComponent } from '../view/dmc-quote-view.component';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';
import { ModalController } from '@ionic/angular';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { DmcQuoteRouteCraftComponent } from './route-craft/dmc-quote-route-craft.component';
import { DmcQuoteHotelPricingComponent } from './hotel-pricing/dmc-quote-hotel-pricing.component';
import { DmcQuoteAddonTicketsComponent } from './addon-tickets/dmc-quote-addon-tickets.component';
import { DmcQuoteInclusionsExclusionsComponent } from './inclusions-exclusions/dmc-quote-inclusions-exclusions.component';
import { DmcQuoteCombinedTermsComponent } from './combined-terms/dmc-quote-combined-terms.component';
import { DmcQuoteImportantInformationComponent } from './important-information/dmc-quote-important-information.component';
import { DmcQuoteNotesComponent } from './notes/dmc-quote-notes.component';
import { DmcQuoteTemplateDataComponent } from './template-data/dmc-quote-template-data.component';

@Component({
  selector: 'app-dmc-quote-form',
  templateUrl: './dmc-quote-form.component.html',
  styleUrls: ['./dmc-quote-form.component.scss'],
})
export class DmcQuoteFormComponent implements OnInit {

  @ViewChild(DmcQuoteItineraryDetailsComponent) itineraryDetailsComponent!: DmcQuoteItineraryDetailsComponent;
  @ViewChild(DmcQuoteRouteCraftComponent) routeCraftComponent!: DmcQuoteRouteCraftComponent;
  @ViewChild(DmcQuoteHotelPricingComponent) dmcHotelPricingComponent!: DmcQuoteHotelPricingComponent;
  @ViewChild(DmcQuoteAddonTicketsComponent) addOnTicketsComponent!: DmcQuoteAddonTicketsComponent;
  @ViewChild(DmcQuoteInclusionsExclusionsComponent) inclusionsAndExclusionsComponent!: DmcQuoteInclusionsExclusionsComponent;
  @ViewChild(DmcQuoteCombinedTermsComponent) combinedTermsComponent!: DmcQuoteCombinedTermsComponent;
  @ViewChild(DmcQuoteImportantInformationComponent) importantInformationComponent!: DmcQuoteImportantInformationComponent;
  @ViewChild(DmcQuoteNotesComponent) notesComponent!: DmcQuoteNotesComponent;
  @ViewChild(DmcQuoteTemplateDataComponent) templatesDetailsComponent!: DmcQuoteTemplateDataComponent;

  leadId: any;
  leadDetails: any;
  itineraryId: any;
  leadTravelServices: any;
  teamplateId: any;

  serviceBasedSections: any = {
    showHotels: true,
    showRouteCraft: true,
    showTourPackage: true
  }

  editInventoryItineraray: any;
  editQuoteItinerary: any;
  parentItineraryId: any = null;

  // All itinearay or quote data
  quoteItineraryData: any;

  // Form data of each tab in add itinerary
  // used to patch data when user gets back to filled tab after submittion
  detailsFormData: any;
  routeCraftFormData: any;
  dmcHotelPricingFormData: any;
  addOnTicketsFormData: any;
  inclusionsAndExclusionsFormData: any;
  termsAndConditionsFormData: any;
  paymentTermsAndConditionsFormData: any;
  cancellationPolicyFormData: any;
  importantInformationFormData: any;
  notesFormData: any;
  templatesDetailsFormData: any;

  quoteStatus: any;
  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;

  orderOfTabs: string[] = ['lead', 'details', 'route', 'accommodation', 'addOnTickets', 'inclusion', 'combined-terms', 'important', 'notes', 'templates-details'];
  orderOfTabsIndex: number = 1;
  componentView: string = this.orderOfTabs[this.orderOfTabsIndex];

  constructor(
    private _modalController: ModalController,
    private _dmcQuoteService: DmcQuotesService,
    private _responseNotificationService: ResponseNotificationService,
    private _leadService: LeadsService,
    private _globalService: GlobalService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _statusUpdateService: StatusUpdateService,
  ) { }

  async ngOnInit() {
    if (this.leadId) {
      await this.getLeadServices();
    }

    if (this.editQuoteItinerary) {
      this.itineraryId = this.editQuoteItinerary
      this._dmcQuoteService.getQuoteData(this.editQuoteItinerary).subscribe((data) => {
        this.quoteItineraryData = data;

        this.assignItineraryQuoteDetails();
      })

    }
  }

  assignItineraryQuoteDetails() {
    // assigning parent ID and status
    this.parentItineraryId = this.quoteItineraryData.itineraryDetails?.parentItineraryId || null;
    this.quoteStatus = this.quoteItineraryData.itineraryDetails?.status || null;

    this.detailsFormData = this.quoteItineraryData.itineraryDetails ? { ...this.detailsFormData, ...this.quoteItineraryData.itineraryDetails } : null;
    this.routeCraftFormData = this.quoteItineraryData.routeCrafts ? { ...this.routeCraftFormData, ...this.quoteItineraryData.routeCrafts } : null;
    this.dmcHotelPricingFormData = this.quoteItineraryData.accommodations ? { ...this.dmcHotelPricingFormData, ...this.quoteItineraryData.accommodations } : null;
    this.addOnTicketsFormData = this.quoteItineraryData.tickets ? { ...this.addOnTicketsFormData, ...this.quoteItineraryData.tickets } : null;
    this.inclusionsAndExclusionsFormData = this.quoteItineraryData.inclusionAndExclusions ? { ...this.inclusionsAndExclusionsFormData, ...this.quoteItineraryData.inclusionAndExclusions } : null;
    this.termsAndConditionsFormData = this.quoteItineraryData.termsAndConditions ? { ...this.termsAndConditionsFormData, ...this.quoteItineraryData.termsAndConditions } : null;
    this.paymentTermsAndConditionsFormData = this.quoteItineraryData.paymentTermsAndConditions ? { ...this.paymentTermsAndConditionsFormData, ...this.quoteItineraryData.paymentTermsAndConditions } : null;
    this.cancellationPolicyFormData = this.quoteItineraryData.cancellationPolicies ? { ...this.cancellationPolicyFormData, ...this.quoteItineraryData.cancellationPolicies } : null;
    this.importantInformationFormData = this.quoteItineraryData.importantInformations ? { ...this.importantInformationFormData, ...this.quoteItineraryData.importantInformations } : null;
    this.notesFormData = this.quoteItineraryData.notes ? { ...this.notesFormData, ...this.quoteItineraryData.notes } : null;
    this.templatesDetailsFormData = this.quoteItineraryData.template ? { ...this.templatesDetailsFormData, ...this.quoteItineraryData.template } : null;

    this.makeAvalibleTabsGreen();
  }

  makeAvalibleTabsGreen() {
    if (this.detailsFormData) {
      this.detailsFormData.dataSaved = true;
    }
    if (this.routeCraftFormData) {
      this.routeCraftFormData.dataSaved = true;
    }
    if (this.dmcHotelPricingFormData) {
      this.dmcHotelPricingFormData.dataSaved = true;
    }
    if (this.addOnTicketsFormData) {
      this.addOnTicketsFormData.dataSaved = true;
    }
    if (this.inclusionsAndExclusionsFormData) {
      this.inclusionsAndExclusionsFormData.dataSaved = true;
    }
    if (this.termsAndConditionsFormData) {
      this.termsAndConditionsFormData.dataSaved = true;
    }
    if (this.paymentTermsAndConditionsFormData) {
      this.paymentTermsAndConditionsFormData.dataSaved = true;
    }
    if (this.cancellationPolicyFormData) {
      this.cancellationPolicyFormData.dataSaved = true;
    }
    if (this.importantInformationFormData) {
      this.importantInformationFormData.dataSaved = true;
    }
    if (this.notesFormData) {
      this.notesFormData.dataSaved = true;
    }
    if (this.templatesDetailsFormData) {
      this.templatesDetailsFormData.dataSaved = true;
    }
  }

  reloadAllChildComponents() {
    if (this.itineraryDetailsComponent) {
      this.itineraryDetailsComponent.ngOnInit();
    }
    if (this.routeCraftComponent) {
      this.routeCraftComponent.ngOnInit();
    }
    if (this.dmcHotelPricingComponent) {
      this.dmcHotelPricingComponent.ngOnInit();
    }
    if (this.addOnTicketsComponent) {
      this.addOnTicketsComponent.ngOnInit();
    }
    if (this.inclusionsAndExclusionsComponent) {
      this.inclusionsAndExclusionsComponent.ngOnInit();
    }
    if (this.combinedTermsComponent) {
      this.combinedTermsComponent.ngOnInit();
    }
    if (this.importantInformationComponent) {
      this.importantInformationComponent.ngOnInit();
    }
    if (this.notesComponent) {
      this.notesComponent.ngOnInit();
    }
    if (this.templatesDetailsComponent) {
      this.templatesDetailsComponent.ngOnInit();
    }
  }

  async getLeadServices(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._leadService.getLead(this.leadId).subscribe({
        next: (data: any) => {
          this.leadDetails = data;
          this.leadDetails.dataSaved = true;
          this.leadTravelServices = data.travelServices;
          // Update tabs based on leads travel services
          this.serviceBasedSections.showHotels = this.leadTravelServices.includes('Hotels') ? true : false;
          this.serviceBasedSections.showRouteCraft = this.leadTravelServices.includes('Sightseeing') ? true : false;
          this.serviceBasedSections.showTourPackage = this.leadTravelServices.includes("Tour Package") ? true : false;

          this.updateListOfTabsForQuote(this.serviceBasedSections);
          this.reloadAllChildComponents();
          resolve();
        },
        error: (err: any) => {
          reject();
        }
      })
    })
  }

  updateListOfTabsForQuote(visibleTabs: any) {
    this.orderOfTabs = ['lead', 'details', 'route', 'accommodation', 'addOnTickets', 'inclusion', 'combined-terms', 'important', 'notes', 'templates-details'];
    if (!visibleTabs.showHotels) {
      let index = this.orderOfTabs.indexOf("accommodation");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }

    if (!visibleTabs.showTransportation && !visibleTabs.showTransfers) {
      let index = this.orderOfTabs.indexOf("transportation");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }

    if (!visibleTabs.showRouteCraft) {
      let index = this.orderOfTabs.indexOf("route");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }
  }

  async closeModal(submitted: boolean = false) {
    if (this.checkCurrentFormDirty(this.componentView) || !this.isQuoteDataValid()) {
      if (await this._globalService.confirmActionPopup("Changes will not be saved, confirm to close", "Quote is invalid", "Confirm")) {
        this.dismissModal(true);
      }
    } else {
      this.dismissModal(true);
    }
  }

  dismissModal(submitted: boolean) {
    this._modalController.dismiss();
  }

  async onViewChange(goPrevious: boolean) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    }
  }

  // Fucntion to change view from clicking on tab buttons
  async onViewChangeFromTab(view: string) {
    // check if current tab is modified
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.changeComponentView(view);
          }
          break
        }
        case 'proceed': {
          this.changeComponentView(view);
          break;
        }
      }
    } else {
      this.changeComponentView(view);
    }
  }

  changeComponentView(view: any) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOfTabs.indexOf(view);
  }

  assignItineraryId(id: string) {
    this.itineraryId = id;
    if (this.leadId) {
      this.getTemplateDetails(this.itineraryId)
    }
  }

  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'details': {
        return this.itineraryDetailsComponent.onSubmit();
      }
      case 'route': {
        return this.routeCraftComponent.onSubmit();
      }
      case 'accommodation': {
        return this.dmcHotelPricingComponent.onSubmit();
      }
      case 'addOnTickets': {
        return this.addOnTicketsComponent.onSubmit();
      }
      case 'inclusion': {
        return this.inclusionsAndExclusionsComponent.onSubmit();
      }
      case 'combined-terms': {
        return this.combinedTermsComponent.onSubmit();
      }
      case 'important': {
        return this.importantInformationComponent.onSubmit();
      }
      case 'notes': {
        return this.notesComponent.onSubmit();
      }
      case 'templates-details': {
        return this.templatesDetailsComponent.onSubmit();
      }
      default: {
        return;
      }

    }
  }

  impactDaysChange() {
    if (this.routeCraftFormData) {
      this.routeCraftFormData.dataInvalid = true;
    }
    if (this.dmcHotelPricingFormData) {
      this.dmcHotelPricingFormData.dataInvalid = true;
    }
  }

  impactGuestsChange() {
    if (this.dmcHotelPricingFormData) {
      this.dmcHotelPricingFormData.dataInvalid = true;
    }
  }

  impactDestinationChanges(){
    if(this.dmcHotelPricingFormData){
      this.dmcHotelPricingFormData.dataInvalid = true;
    }
    if(this.addOnTicketsFormData){
      this.addOnTicketsFormData.dataInvalid = true;
    }
  }

  tourPackageRemovedImpact(){
    if (this.dmcHotelPricingFormData) {
      this.dmcHotelPricingFormData.dataInvalid = true;
    }
  }

  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'details': {
        return (this.itineraryDetailsComponent?.formDataModified());
      }
      case 'route': {
        return (this.routeCraftComponent?.formDataModified());
      }
      case 'accommodation': {
        return (this.dmcHotelPricingComponent?.formDataModified());
      }
      case 'addOnTickets': {
        return (this.addOnTicketsComponent?.formDataModified());
      }
      case 'inclusion': {
        return (this.inclusionsAndExclusionsComponent?.formDataModified());
      }
      case 'combined-terms': {
        return (this.combinedTermsComponent?.formDataModified());
      }
      case 'important': {
        return (this.importantInformationComponent?.formDataModified());
      }
      case 'notes': {
        return (this.notesComponent?.formDataModified());
      }
      case 'templates-details': {
        return (this.templatesDetailsComponent?.formDataModified());
      }

      default: {
        return false;
      }
    }
  }

  // Storing tab data here when add API of that respective tab is called

  storeDetailsData(formData: any) {
    this.detailsFormData = formData
  }

  storeRouteCraftData(formData: any) {
    this.routeCraftFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }

  storeDmcHotelPricingData(formData: any) {
    this.dmcHotelPricingFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }

  storeAddOnTicketsData(formData: any) {
    this.addOnTicketsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  storeInclusionsAndExclusionData(formData: any) {
    this.inclusionsAndExclusionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  storeTermsAndConditionsData(formData: any) {
    this.termsAndConditionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storePaymentTermsAndConditionsData(formData: any) {
    this.paymentTermsAndConditionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeCancellationPolicyData(formData: any) {
    this.cancellationPolicyFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeImportantInformationData(formData: any) {
    this.importantInformationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeNotesData(formData: any) {
    this.notesFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  storeTemplateDetailsData(formData: any) {
    this.templatesDetailsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  async openReviewScreen() {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.openQuoteReview();
          }
          break
        }
        case 'proceed': {
          this.openQuoteReview();
          break;
        }
      }
    } else {
      this.openQuoteReview();
    }
  }

  async openQuoteReview() {
    if (this.isQuoteDataValid()) {
      await this._modalPopupService.closeAllModals();
      if (this.leadId) {
        this.openReviewItineraryView(this.itineraryId, this.leadId, this.detailsFormData.clientId);
      } else {
        this._modalPopupService.openInventoryItineraryView(this.itineraryId, null, null);
      }
    } else {
      this._globalService.customAlert("Validate all sections", "Quote is invalid");
    }

  }

  async openReviewItineraryView(quoteId: any, leadId: any, clientId: any) {
    const modal = await this._modalController.create({
      component: DmcQuoteViewComponent,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        quoteId: quoteId,
        leadId: leadId,
        clientId: clientId
      }
    });

    await modal.present();
  }

  getTemplateDetails(quoteId: any) {
    this._dmcQuoteService.getQuoteData(quoteId).subscribe((data) => {
      this.templatesDetailsFormData = data.template;
      this.templatesDetailsFormData.dataSaved = true;
    })
  }


  // Function to update quite and flight details
  async updateQuote() {
    this.serializeQuoteFormData().then(formData => {
      const apiItineraryId = this.parentItineraryId ? this.parentItineraryId : this.editQuoteItinerary;
      this._dmcQuoteService.updateQuote(apiItineraryId, formData).subscribe(async (data: any) => {
        this._responseNotificationService.showMessage("Quote Updated!");

        // Assigning new responce data to global variable
        this.editQuoteItinerary = data.itineraryDetails.itineraryId;
        this.itineraryId = data.itineraryDetails.itineraryId;
        this.quoteItineraryData = data;
        this.assignItineraryQuoteDetails();
        this.reloadAllChildComponents();
        this._reloadService.triggerQuotesReload();
      });
    });
  }

  isQuoteDataValid(): boolean {
    // List of all form data objects
    const formDataList = [
      this.detailsFormData,
      this.addOnTicketsFormData
    ];

    if (this.serviceBasedSections.showHotels) {
      formDataList.push(this.dmcHotelPricingFormData);
    }

    if (this.serviceBasedSections.showRouteCraft) {
      formDataList.push(this.routeCraftFormData);
    }

    for (let formData of formDataList) {
      if (formData?.dataInvalid === true) {
        return false;
      }
    }

    // If none of the objects have 'dataInvalid' as true, return true
    return true;
  }

  // Function to serialize the quote modal
  private async serializeQuoteFormData() {
    const serializedData = {
      itineraryDetails: {
        ...this.detailsFormData,
        parentItineraryId: this.parentItineraryId,
        section: this.quoteItineraryData?.itineraryDetails ? this.quoteItineraryData.itineraryDetails.section : null,
        category: this.quoteItineraryData?.itineraryDetails ? this.quoteItineraryData.itineraryDetails.category : null,
      },
      routeCrafts : this.routeCraftFormData ? {
        ...this.routeCraftFormData,
        section: this.quoteItineraryData?.routeCrafts ? this.quoteItineraryData.routeCrafts.section : null,
        category: this.quoteItineraryData?.routeCrafts ? this.quoteItineraryData.routeCrafts.category : null,
      } : null,
      accommodations: this.dmcHotelPricingFormData ? {
        ...this.dmcHotelPricingFormData,
        section: this.quoteItineraryData?.accommodations ? this.quoteItineraryData.accommodations.section : null,
        category: this.quoteItineraryData?.accommodations ? this.quoteItineraryData.accommodations.category : null,
      } : null,
      tickets: this.addOnTicketsFormData ? {
        ...this.addOnTicketsFormData,
        section: this.quoteItineraryData?.tickets ? this.quoteItineraryData.tickets.section : null,
        category: this.quoteItineraryData?.tickets ? this.quoteItineraryData.tickets.category : null,
      } : null,
      inclusionAndExclusions: this.inclusionsAndExclusionsFormData ? {
        ...this.inclusionsAndExclusionsFormData,
        section: this.quoteItineraryData?.inclusionAndExclusions ? this.quoteItineraryData.inclusionAndExclusions.section : null,
        category: this.quoteItineraryData?.inclusionAndExclusions ? this.quoteItineraryData.inclusionAndExclusions.category : null,
      } : null,
      termsAndConditions: this.termsAndConditionsFormData ? {
        ...this.termsAndConditionsFormData,
        section: this.quoteItineraryData?.termsAndConditions ? this.quoteItineraryData.termsAndConditions.section : null,
        category: this.quoteItineraryData?.termsAndConditions ? this.quoteItineraryData.termsAndConditions.category : null,
      } : null,
      paymentTermsAndConditions: this.paymentTermsAndConditionsFormData ? {
        ...this.paymentTermsAndConditionsFormData,
        section: this.quoteItineraryData?.paymentTermsAndConditions ? this.quoteItineraryData.paymentTermsAndConditions.section : null,
        category: this.quoteItineraryData?.paymentTermsAndConditions ? this.quoteItineraryData.paymentTermsAndConditions.category : null,
      } : null,
      cancellationPolicies: this.cancellationPolicyFormData ? {
        ...this.cancellationPolicyFormData,
        section: this.quoteItineraryData?.cancellationPolicies ? this.quoteItineraryData.cancellationPolicies.section : null,
        category: this.quoteItineraryData?.cancellationPolicies ? this.quoteItineraryData.cancellationPolicies.category : null,
      } : null,
      importantInformations: this.importantInformationFormData ? {
        ...this.importantInformationFormData,
        section: this.quoteItineraryData?.importantInformations ? this.quoteItineraryData.importantInformations.section : null,
        category: this.quoteItineraryData?.importantInformations ? this.quoteItineraryData.importantInformations.category : null,
      } : null,
      notes: this.notesFormData ? {
        ...this.notesFormData,
        section: this.quoteItineraryData?.notes ? this.quoteItineraryData.notes.section : null,
        category: this.quoteItineraryData?.notes ? this.quoteItineraryData.notes.category : null,
      } : null,
      template: this.templatesDetailsFormData ? {
        ...this.templatesDetailsFormData,
        section: this.quoteItineraryData?.template ? this.quoteItineraryData.template.section : null,
        category: this.quoteItineraryData?.template ? this.quoteItineraryData.template.category : null,
      } : null,
    }

    return serializedData;
  }

  async submitQuote() {
    if (await this._globalService.confirmActionPopup("Submitting a quote will start creating versions when updated.", "Confirm To Submit")) {
      this.makeQuoteActive();
    }
  }

  makeQuoteActive() {
    this._dmcQuoteService.getQuoteData(this.itineraryId).subscribe(async (data: any) => {
      let keys = Object.keys(data);
      let leadId = data.itineraryDetails.leadId;

      try {
        // Wait for lead travel services to be fetched
        let leadTravelServices = await this._globalService.getLeadsTravelServices(leadId);

        if (!leadTravelServices.showHotels) {
          keys = keys.filter(item => item !== "accommodations");
        }
        if (!leadTravelServices.showRouteCraft) {
          keys = keys.filter(item => item !== "routeCrafts");
        }
        // Revovining transport related keys
        keys = keys.filter(item => !["notes", "tickets" , "paymentTermsAndConditions"].includes(item));


        // Check if any data keys are null
        for (let key of keys) {
          if (data[key] === null) {
            await this._globalService.customAlert("Fill all quote details to submit");
            return;
          }
        }

        // Update status after validation
        this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.DMC_QUOTE, this.itineraryId, RECORD_STATUS_VALUES.ACTIVE).subscribe(async (data: any) => {
          if (data) {
            this._responseNotificationService.showMessage("Quote Is Active!");

            // await this.saveAsInventoryItinerary(this.itineraryId);

            await this._modalPopupService.closeAllModals();
            this._modalPopupService.openReviewDmcQuoteView(this.itineraryId, leadId, this.detailsFormData.clientId);
          }
          this._reloadService.triggerQuotesReload();
        });

      } catch (error) {
        console.error('Error fetching lead travel services:', error);
      }
    });
  }

  async saveAsInventoryItinerary(quoteId: any) {
    if (await this._globalService.confirmActionPopup("Do you want to save this quote in Inventory?", "Save in inventory", "Yes")) {
      this._dmcQuoteService.saveAsInventoryItinerary(quoteId).subscribe((data: any) => {
        if (data) {
          this._responseNotificationService.showMessage("Quote saved as Inventory Itinerary!");
        }
      },
        (error: any) => {
          this._responseNotificationService.showMessage("Failed to save as Inventory Itinerary!", true);
        }
      )
    }
  }

  showSubmitButton(): boolean {
    if (this.componentView !== 'lead' && this.leadId && this.quoteStatus === RECORD_STATUS_VALUES.DRAFT) {
      const formDataList = [
        this.detailsFormData
      ];

      for (let formData of formDataList) {
        if (!formData || formData?.dataInvalid === true) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }

  }

}
